/* ==========================================================================
   shiftcam-sticky-anchor-nav.js
   ========================================================================== */

(function () {
  function init() {
    var navEls = document.querySelectorAll('.shiftcam-sticky-anchor-nav');
    if (!navEls.length) return;

    navEls.forEach(function (nav) {
      var sectionWrapper = nav.closest('[id^="shopify-section-"]');
      var el = sectionWrapper || nav;

      function getNavHeight() {
        return el.getBoundingClientRect().height;
      }

      function scrollToTarget(target) {
        var offset = getNavHeight();
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      /* ── is-stuck: add shadow only when nav is pinned to top ─────── */
      // naturalTop = distance from top of page to section in normal flow.
      // When scrollY exceeds that, the section is stuck at top: 0.
      var naturalTop = el.offsetTop;

      function checkStuck() {
        nav.classList.toggle('is-stuck', window.scrollY > naturalTop);
      }

      window.addEventListener('scroll', checkStuck, { passive: true });
      checkStuck(); // run once on init

      /* ── scroll-margin-top on anchor targets ────────────────────── */
      var allLinks = nav.querySelectorAll('[data-anchor-link]');

      function setScrollMargins() {
        var h = getNavHeight();
        allLinks.forEach(function (link) {
          var href = link.getAttribute('href');
          if (href && href.startsWith('#')) {
            var el = document.querySelector(href);
            if (el) el.style.scrollMarginTop = h + 'px';
          }
        });
      }

      setScrollMargins();
      window.addEventListener('resize', setScrollMargins);

      /* ── smooth scroll on click ─────────────────────────────────── */
      nav.addEventListener('click', function (e) {
        var link = e.target.closest('[data-anchor-link]');
        if (!link) return;

        var href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;

        var target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        scrollToTarget(target);

        if (history.pushState) {
          history.pushState(null, null, href);
        }
      });

      /* ── IntersectionObserver: active state ─────────────────────── */
      var targets = [];
      allLinks.forEach(function (link) {
        var href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
          var target = document.querySelector(href);
          if (target) targets.push({ link: link, el: target });
        }
      });

      if (targets.length) {
        var activeObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                allLinks.forEach(function (l) { l.classList.remove('active'); });
                var activeId = '#' + entry.target.id;
                allLinks.forEach(function (l) {
                  if (l.getAttribute('href') === activeId) {
                    l.classList.add('active');
                  }
                });
              }
            });
          },
          { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
        );

        targets.forEach(function (t) { activeObserver.observe(t.el); });
      }

      /* ── Add to cart ────────────────────────────────────────────── */
      var btn = nav.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.addEventListener('click', function () {
          var variantId = btn.dataset.variantId;
          if (!variantId) return;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function (err) {
            console.warn('[shiftcam-sticky-anchor-nav] add to cart failed:', err);
          });
        });
      }
    }); // end navEls.forEach
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.shiftcam-sticky-anchor-nav')) {
      init();
    }
  });
})();